module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"angular","commonjs2":"angular","commonjs":"angular","amd":"angular"}
 ** module id = 2
 ** module chunks = 0
 **/